export type ParsedPlaywrightSignupIdentity =
  | {
      status: 'valid';
      email: string;
      attemptId: string;
    }
  | {
      status: 'malformed' | 'not-reserved';
      email: string;
    };

const ATTEMPT_PATTERN =
  /^(?:gh-[a-z0-9]{1,12}-a[a-z0-9]+|local-[0-9]+)-s[0-9]+-w[0-9]+-r[0-9]+-[a-z0-9]{8}$/;

export function parsePlaywrightSignupIdentity(
  input: string
): ParsedPlaywrightSignupIdentity {
  const email = input.trim().toLowerCase();
  const separatorIndex = email.indexOf('@');
  const hasOneSeparator =
    separatorIndex > 0 && separatorIndex === email.lastIndexOf('@');
  const localPart = hasOneSeparator ? email.slice(0, separatorIndex) : '';
  const domain = hasOneSeparator ? email.slice(separatorIndex + 1) : '';

  if (domain !== 'vrp.rocks' || !localPart.startsWith('e2e-sign-up')) {
    return { status: 'not-reserved', email };
  }

  const marker = '+clerk_test_';
  const markerIndex = localPart.indexOf(marker);
  const base = markerIndex === -1 ? localPart : localPart.slice(0, markerIndex);
  const attemptId =
    markerIndex === -1 ? '' : localPart.slice(markerIndex + marker.length);

  if (
    base !== 'e2e-sign-up' ||
    markerIndex !== base.length ||
    localPart.length > 64 ||
    !ATTEMPT_PATTERN.test(attemptId)
  ) {
    return { status: 'malformed', email };
  }

  return { status: 'valid', email, attemptId };
}
